export default {
  en: {
    noMessages: 'No messages',
    title: 'Messages',
    clearTooltip: 'Remove',
    btnClearAll: 'Clear all',
    stopReportingThat: 'OK, stop reporting that',
  },
};
